import * as React from 'react';

const MOBILE_BREAKPOINT = 768;
const TABLET_BREAKPOINT = 1024;

// Generic hook for responsive breakpoints
function useResponsiveBreakpoint(breakpoint: number) {
  const [isBelowBreakpoint, setIsBelowBreakpoint] = React.useState<boolean | undefined>(undefined);
  const [isHydrated, setIsHydrated] = React.useState(false);

  React.useEffect(() => {
    // Mark as hydrated on client side
    setIsHydrated(true);

    const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    const onChange = () => {
      setIsBelowBreakpoint(window.innerWidth < breakpoint);
    };

    // Set initial value
    setIsBelowBreakpoint(window.innerWidth < breakpoint);

    // Add event listener
    mql.addEventListener('change', onChange);

    return () => mql.removeEventListener('change', onChange);
  }, [breakpoint]);

  // Return undefined during SSR and initial hydration to prevent hydration mismatch
  if (!isHydrated) {
    return undefined;
  }

  return !!isBelowBreakpoint;
}

export function useIsMobile() {
  return useResponsiveBreakpoint(MOBILE_BREAKPOINT);
}

export function useIsTablet() {
  return useResponsiveBreakpoint(TABLET_BREAKPOINT);
}
